export default __webpack_public_path__ + "static/media/old-man-reading-book.fba5a45e.jpg";